// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.about_container_about__SNdhw {
  width: 60%;
  margin-top: 3%; 
  margin-left: 15%; 
  display: flex; 
  flex: 1 1; 
  flex-direction: column; 
  align-content: flex-start;
  align-items: flex-start;
  align-self: center;
}

.about_about_info__Ug75v{
 display: flex ; 
 flex-direction: row; 
  align-content: flex-start;
  align-items: flex-start;
  align-self: flex-start; 
 align-content: space-between;
 justify-content: space-between; 
}

.about_about_info_text__sDTOc{
 display: flex ; 
 flex-direction: column; 
 align-items: flex-start; 
 align-content: space-between;
 justify-content: center; 
 width: 40%;
}


.about_about_signup_block__4FwxL{
 display: flex ; 
 flex-direction: column; 
 align-items: center; 
 align-content: center;
 align-self: center;
 padding-top: 60px;
}

.about_logos__Fl5Du {
  display: flex;
  flex: 1 1;
    align-content: flex-start;
  align-items: flex-start;
  align-self: center;
  vertical-align: bottom;

  width: 200px;
  height: 80px;
  margin-right: 15%; }

.about_imageGroup_department_logos__FGjgd {
  display: flex; 
  flex: 1 1; 
  flex-direction: row; 
  align-content: flex-start;
  align-items: flex-start;
  align-self: flex-start;

}

`, "",{"version":3,"sources":["webpack://./src/pages/About/about.module.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,SAAO;EACP,sBAAsB;EACtB,yBAAyB;EACzB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;CACC,cAAc;CACd,mBAAmB;EAClB,yBAAyB;EACzB,uBAAuB;EACvB,sBAAsB;CACvB,4BAA4B;CAC5B,8BAA8B;AAC/B;;AAEA;CACC,cAAc;CACd,sBAAsB;CACtB,uBAAuB;CACvB,4BAA4B;CAC5B,uBAAuB;CACvB,UAAU;AACX;;;AAGA;CACC,cAAc;CACd,sBAAsB;CACtB,mBAAmB;CACnB,qBAAqB;CACrB,kBAAkB;CAClB,iBAAiB;AAClB;;AAEA;EACE,aAAa;EACb,SAAO;IACL,yBAAyB;EAC3B,uBAAuB;EACvB,kBAAkB;EAClB,sBAAsB;;EAEtB,YAAY;EACZ,YAAY;EACZ,iBAAiB,EAAE;;AAErB;EACE,aAAa;EACb,SAAO;EACP,mBAAmB;EACnB,yBAAyB;EACzB,uBAAuB;EACvB,sBAAsB;;AAExB","sourcesContent":[".container_about {\r\n  width: 60%;\r\n  margin-top: 3%; \r\n  margin-left: 15%; \r\n  display: flex; \r\n  flex: 1; \r\n  flex-direction: column; \r\n  align-content: flex-start;\r\n  align-items: flex-start;\r\n  align-self: center;\r\n}\r\n\r\n.about_info{\r\n display: flex ; \r\n flex-direction: row; \r\n  align-content: flex-start;\r\n  align-items: flex-start;\r\n  align-self: flex-start; \r\n align-content: space-between;\r\n justify-content: space-between; \r\n}\r\n\r\n.about_info_text{\r\n display: flex ; \r\n flex-direction: column; \r\n align-items: flex-start; \r\n align-content: space-between;\r\n justify-content: center; \r\n width: 40%;\r\n}\r\n\r\n\r\n.about_signup_block{\r\n display: flex ; \r\n flex-direction: column; \r\n align-items: center; \r\n align-content: center;\r\n align-self: center;\r\n padding-top: 60px;\r\n}\r\n\r\n.logos {\r\n  display: flex;\r\n  flex: 1;\r\n    align-content: flex-start;\r\n  align-items: flex-start;\r\n  align-self: center;\r\n  vertical-align: bottom;\r\n\r\n  width: 200px;\r\n  height: 80px;\r\n  margin-right: 15%; }\r\n\r\n.imageGroup_department_logos {\r\n  display: flex; \r\n  flex: 1; \r\n  flex-direction: row; \r\n  align-content: flex-start;\r\n  align-items: flex-start;\r\n  align-self: flex-start;\r\n\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container_about": `about_container_about__SNdhw`,
	"about_info": `about_about_info__Ug75v`,
	"about_info_text": `about_about_info_text__sDTOc`,
	"about_signup_block": `about_about_signup_block__4FwxL`,
	"logos": `about_logos__Fl5Du`,
	"imageGroup_department_logos": `about_imageGroup_department_logos__FGjgd`
};
export default ___CSS_LOADER_EXPORT___;
